module.exports = __webpack_public_path__ + "static/media/close-tooltip.8d6eab6e.svg";